/* Modulo: Hero Proof — stat count-up. Vanilla, lazy, reduced-motion safe. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseValue(text) {
    var match = String(text).match(/-?\d+(?:[.,]\d+)?/);
    if (!match) return null;
    var raw = match[0].replace(',', '.');
    return {
      number: parseFloat(raw),
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + match[0].length),
      decimals: (raw.split('.')[1] || '').length
    };
  }

  function format(parts, value) {
    var n = parts.decimals > 0 ? value.toFixed(parts.decimals) : Math.round(value).toString();
    return parts.prefix + n + parts.suffix;
  }

  function animate(el) {
    if (el.dataset.moduloHpDone === '1') return;
    el.dataset.moduloHpDone = '1';
    var original = el.textContent.trim();
    var parts = parseValue(original);
    if (!parts) return;
    if (REDUCE) { el.textContent = original; return; }

    var duration = 1400;
    var start = null;
    el.textContent = format(parts, 0);

    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = format(parts, parts.number * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = original;
    }
    requestAnimationFrame(step);
  }

  function runStats(container) {
    var nums = container.querySelectorAll('[data-modulo-hp-count]');
    for (var i = 0; i < nums.length; i++) animate(nums[i]);
  }

  function initSection(el) {
    if (el.dataset.moduloHpInit === '1') return;
    el.dataset.moduloHpInit = '1';

    var stats = el.querySelector('[data-modulo-hp-stats]');
    if (!stats) return;

    if (!('IntersectionObserver' in window)) {
      runStats(stats);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runStats(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    io.observe(stats);
  }

  function initAll() {
    var els = document.querySelectorAll('[data-modulo-hp]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added / re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-modulo-hp]') : null;
    if (el) initSection(el);
  });
})();
